/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Grid, makeStyles, Typography,
} from '@material-ui/core';

import kamiprueba from '../../assets/img/bot-kami.png';
import { GetCourses, GetUserInscription } from '../../services/courses';
import { setAnalytics } from '../../utils';
import ReturnButton from '../General/ReturnButton';

import SkeletonAllNotes from './SkeletonAllNotes';
import SkeletonInitNotes from './SkeletonInitNotes';
import Summary from './Summary';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(2, 6),
  },
  summary: {
    margin: theme.spacing(3, 22),
  },
  notesTitle: {
    fontSize: '35px',
    fontFamily: 'Raleway',
    fontWeight: 400,
    color: theme.palette.text.default,
  },
  containerNoneNotes: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(7, 2),
  },
  containerNoneNotesImg: {
    width: 190,
  },
  containerNoneNotesText: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    fontSize: 30,
    textAlign: 'center',
    margin: theme.spacing(0, 0, 3, 0),
  },
  containerNoneNotesTextContainer: {
    width: 550,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    margin: theme.spacing(0, 8),
  },
}));

function Index() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const { sub } = useSelector((store) => store.login);
  const [isInscription, setIsInscription] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getAllCourses = async () => {
    const allGetCourses = await GetCourses();
    const getInscription = await GetUserInscription(sub);
    setIsInscription(getInscription.data.inscribed);
    const filterCourses = allGetCourses.data.filter((e) => e.status === 'enabled');
    setCourses(filterCourses);
    setIsLoading(false);
  };

  const handleNavigateToCourses = () => navigate('/home');

  useEffect(() => {
    getAllCourses();
    setAnalytics('Home', 'NavPerfil_MisNotas');
  }, []);

  return (
    <Grid>
      <Grid className={classes.button}>
        <ReturnButton />
      </Grid>
      <Grid className={classes.summary}>
        { isLoading ? <SkeletonInitNotes /> : isInscription ? (
          <>
            <Typography className={classes.notesTitle}>Mis notas</Typography>
            <Box>
              {courses.length !== 0
              && courses.sort((a, b) => (a.createdAt - b.createdAt))
                .map((course) => <Summary key={course.id} course={course} />)}
            </Box>

          </>
        ) : (
          <Box className={classes.containerNoneNotes}>
            <Box>
              <img
                src={kamiprueba}
                alt="kamibot"
                className={classes.containerNoneNotesImg}
              />

            </Box>
            <Box className={classes.containerNoneNotesTextContainer}>
              <Typography className={classes.containerNoneNotesText}>
                Debes matricularte a un curso para
                poder comenzar a crear tus notas
              </Typography>
              <Box>
                <Button variant="contained" color="secondary" onClick={handleNavigateToCourses}>IR A CURSOS</Button>
              </Box>
            </Box>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}

export default Index;
